import { render } from "./DaodiHerbsList.vue?vue&type=template&id=4a750a33&scoped=true"
import script from "./DaodiHerbsList.vue?vue&type=script&lang=js"
export * from "./DaodiHerbsList.vue?vue&type=script&lang=js"

import "./DaodiHerbsList.vue?vue&type=style&index=0&id=4a750a33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.106.2_@swc+core@1.3.96_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a750a33"]])

export default __exports__